import React, { Component } from "react";
import Instructions from "../../components/extract/Instructions";
import PromptService from "../../services/api/prompt";
import { Card, Col, Form, InputGroup, Pagination, Row } from "react-bootstrap";

class PromptList extends Component{
    constructor(props){
        super(props)
        this.state = {
            instructionDataSource: [],
            promptPageNumber: 0,
            promptTotalPages: 0,
            loading: false,
            gotoNewInst: false,
            instructionEditId: "",
            searchQuery: "",
            filteredDataSource: [],
            viewMode: 'grid'
        }
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        this.getInstructionList();
    }

    updateWindowDimensions = () => {
        this.setState({
            height: window.innerHeight
        })
    }

    getInstructionList = () => {
        this.setState({
            loading: true
        })
        let filterName = {
            "name": this.state.searchQuery
        }
        PromptService.filterInstructionList(this.state.promptPageNumber, 20, filterName)
            .then((response) => {
                if (response.status === "SUCCESS" && response.promptDTOPage !== null) {
                    this.setState({
                        instructionDataSource: response?.promptDTOPage?.content,
                        filteredDataSource: response?.promptDTOPage?.content,
                        promptTotalPages: response?.promptDTOPage?.totalPages,
                        loading: false
                    });
                }
            }).catch((error) => {
                this.setState({ loading: false });
            })
    }

    handleSearchChange = (e) => {
        const query = e.target.value;
        this.setState({
            searchQuery: query,
            promptPageNumber: 0 
        }, () => {
            this.filterInstructionsLocally(query);
            this.getInstructionList();
        });
    }

    filterInstructionsLocally = (query) => {
        if (!query.trim()) {
            this.setState({
                filteredDataSource: this.state.instructionDataSource
            });
            return;
        }

        const filtered = this.state.instructionDataSource.filter(instruction =>
            instruction.name?.toLowerCase().includes(query.toLowerCase()) ||
            instruction.description?.toLowerCase().includes(query.toLowerCase()) ||
            instruction.instruction?.toLowerCase().includes(query.toLowerCase())
        );

        this.setState({
            filteredDataSource: filtered
        });
    }
    
    _onPromptPageChange = (pageIndex) => {
        this.setState({
            promptPageNumber: pageIndex
        }, () => {
            this.getInstructionList();
        })
    }
    
    enablePrompt = () => {
        this.setState({
            gotoNewInst: true
        })
    }

    _closeInstructModal = () => {
        this.setState({
            gotoNewInst: false
        })
    }

    _renderInstructionList = () => {
        this.getInstructionList();
    }

    _editInstruction = (id) => {
        this.setState({instructionEditId: id})
    }

    handleViewModeChange = (mode) => {
        this.setState({
            viewMode: mode
        });
    };

    render() {

        return(
            <Card className="extract-main main-bread-crumb extract">
            <Row className="py-2 px-0 app-sticky mx-0">
                <Col xl={4} lg={4} md={12} sm={12} xs={12} className="d-flex flex-column app-head">
                    <span className="font-bold txt-black main-title">Prompt</span>
                    <span className="font-regular sub-content">Manage your Prompt</span>
                </Col>
                
                <Col xl={4} lg={4} md={12} sm={12} xs={12} className="d-flex align-items-center justify-content-center">
                    <div className="w-100" style={{ maxWidth: '400px' }}>
                        <InputGroup>
                            <InputGroup.Text style={{ 
                                backgroundColor: 'white', 
                                border: '1px solid #e9ecef',
                                borderRight: 'none'
                            }}>
                                <i className="fas fa-search text-muted"></i>
                            </InputGroup.Text>
                            <Form.Control
                                type="text"
                                placeholder="Search Prompt"
                                value={this.state.searchQuery}
                                onChange={this.handleSearchChange}
                                style={{
                                    border: '1px solid #e9ecef',
                                    borderLeft: 'none',
                                    backgroundColor: 'white',
                                    fontSize: '0.9rem'
                                }}
                            />
                        </InputGroup>
                    </div>
                </Col>
                
                <Col xl={4} lg={4} md={12} sm={12} xs={12} className="d-flex justify-content-end align-items-center add-app-btn">   
                    <div className="btn-group me-3" role="group" aria-label="View mode toggle">
                        <button
                            type="button"
                            className={`btn ${this.state.viewMode === 'grid' ? 'btn-primary' : 'btn-outline-secondary'}`}
                            onClick={() => this.handleViewModeChange('grid')}
                            style={{
                                borderRadius: '6px 0 0 6px',
                                border: '1px solid #e9ecef',
                                padding: '8px 12px',
                                fontSize: '0.85rem',
                                fontWeight: '500'
                            }}
                        >
                            <i className="fas fa-th"></i>
                        </button>
                        <button
                            type="button"
                            className={`btn ${this.state.viewMode === 'list' ? 'btn-primary' : 'btn-outline-secondary'}`}
                            onClick={() => this.handleViewModeChange('list')}
                            style={{
                                borderRadius: '0 6px 6px 0',
                                border: '1px solid #e9ecef',
                                padding: '8px 12px',
                                fontSize: '0.85rem',
                                fontWeight: '500'
                            }}
                        >
                            <i className="fas fa-list"></i>
                        </button>
                    </div>

                    <span className="btn rounded-pill px-4 py-2" style={{
                        background: "#4880FF",
                        color: "white",
                        border: "none",
                        fontSize: "0.95rem",
                        fontWeight: "500",
                        transition: "all 0.2s ease",
                        textDecoration: "none",
                        boxShadow: "0 2px 4px rgba(72, 128, 255, 0.1)"
                    }} onClick={e => this.enablePrompt(e)}>
                        <i className="fas fa-plus me-2"></i>
                        Add Prompt
                    </span>
                </Col>
            </Row>
            <div className="p-2">
                <Instructions 
                    instructionDataSource={this.state.filteredDataSource}
                    gotoNewInst={this.state.gotoNewInst}
                    _renderInstructionList={this._renderInstructionList}
                    _closeInstructModal={this._closeInstructModal}
                    _editInstruction={this._editInstruction}
                    viewMode={this.state.viewMode}
                />
                {this.state.instructionDataSource?.length !== 0 && this.state.instructionDataSource?.length >= 5 &&  this.state.promptTotalPages > 1 && <div className="page-footer">
                    <Pagination className="my-5" size="">
                        <Pagination.Prev
                            onClick={() => this._onPromptPageChange(this.state.promptPageNumber - 1)}
                            disabled={this.state.promptPageNumber === 0}
                        />
                        {[...Array(this.state.promptTotalPages)].map((_, index) => (
                            <Pagination.Item
                                key={index}
                                active={index === this.state.promptPageNumber}
                                onClick={() => this._onPromptPageChange(index)}
                            >
                                {index + 1}
                            </Pagination.Item>
                        ))}
                        <Pagination.Next
                            onClick={() => this._onPromptPageChange(this.state.promptPageNumber + 1)}
                            disabled={this.state.promptPageNumber === this.state.promptTotalPages - 1}
                        />
                    </Pagination>
                </div>}
            </div>
            </Card>

        )
    }
}

export default PromptList;